var _path, _path2, _path3;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgHarddrives(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 13,
    height: 11,
    viewBox: "0 0 13 11",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1 8.72115L1 5.91346L2.74077 1.85073C2.84909 1.59804 3.02923 1.38272 3.25883 1.23148C3.48842 1.08024 3.75738 0.999756 4.03231 1H9.19987C9.47456 1.00003 9.74321 1.08065 9.97253 1.23187C10.2019 1.38308 10.3818 1.59826 10.49 1.85073L12.2308 5.91346V8.72115C12.2308 9.09348 12.0829 9.45055 11.8196 9.71382C11.5563 9.9771 11.1992 10.125 10.8269 10.125H2.40385C2.03152 10.125 1.67445 9.9771 1.41118 9.71382C1.1479 9.45055 1 9.09348 1 8.72115Z",
    stroke: "#A649B8",
    strokeWidth: 0.701923,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M3.45834 7.66526C3.45834 7.2776 3.14407 6.96334 2.75641 6.96334C2.36875 6.96334 2.05449 7.2776 2.05449 7.66526C2.05449 8.05293 2.36875 8.36719 2.75641 8.36719C3.14407 8.36719 3.45834 8.05293 3.45834 7.66526Z",
    fill: "#A649B8"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M1.35347 5.91406L11.8823 5.91406",
    stroke: "#A649B8",
    strokeWidth: 0.701923,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgHarddrives);
export default __webpack_public_path__ + "static/media/harddrives.8207bfdb8795b8b15c524f5a0413c97f.svg";
export { ForwardRef as ReactComponent };